import { PaymentRequirementsHistoryItem } from "../history/payment-requirements-history.interface";

export enum PaymentRequirementsField {
	withAccept = 'withAccept',
	unpaid = 'unpaid',
	paymentType = 'paymentType',
	documentNumber = 'documentNumber',
	documentDate = 'documentDate',
	debitName = 'debitName',
	debitInn = 'debitInn',
	debitAccountNumber = 'debitAccountNumber',
	debitMfo = 'debitMfo',
	debitMfoName = 'debitMfoName',
	requesterName = 'requesterName',
	requesterInn = 'requesterInn',
	requesterAccountNumber = 'requesterAccountNumber',
	requesterMfo = 'requesterMfo',
	requesterMfoName = 'requesterMfoName',
	purposeCode = 'purposeCode',
	paymentAmount = 'paymentAmount',
	purpose = 'purpose',
	rejectionReason = 'rejectionReason',
	rejectionFiles = 'rejectionFiles',
	debitPinfl = 'debitPinfl',
	requesterPinfl = 'requesterPinfl',
	amount = 'amount',
}

export enum PaymentRequirementsIncomingStatus {
	ACCEPTED = '1',
	WITHDRAWN = '2',
	PAID = '3',
	CAPITALIZED_K1 = '4',
	CAPITALIZED_K2 = '5',
	PROCESSING_TIME_EXPIRED = '6',
	DENIED = '7',
	WAITING_PAYMENT_COMPLETE = '-1',
}

export enum PaymentRequirementsOutgoingStatus {
	UNDEFINED = '0',
	CREATED = '1',
	REMOVED = '2',
	SENT = '3',
	REJECTED_BY_BOARD_BANK = '4',
	ACCEPTED_BY_BANK_PAYMENTS = '5',
	CAPITALIZED_K1 = '6',
	CAPITALIZED_K2 = '7',
	PAID = '8',
	WITHDRAWN = '9',
	DENIED = 'A',
	PROCESSING_TIME_EXPIRED = 'B',
}

export interface PaymentRequirementsItem {
	outgoingPaymentStatus?: string | null
	confirmText?: string | null
	income?: boolean | null
	documentNumber?: string | null
	documentDate?: string | null
	receiveDate?: string | null
	requesterName?: string | null
	requesterAccountNumber?: string | null
	requesterMfo?: string | null
	requesterMfoName?: string | null
	requesterInn?: string | null
	requesterPinfl?: string | null
	debitAccountNumber?: string | null
	debitMfo?: string | null
	debitMfoName?: string | null
	debitName?: string | null
	debitInn?: string | null
	debitPinfl?: string | null
	paymentType?: string | null
	paymentTypeName?: string | null
	purposeCode?: string | null
	purposeCodeName?: string | null
	unpaid?: string | null
	unpaidName?: string | null
	amount?: number
	purpose?: string | null
	status?: PaymentRequirementsItemStatus | null
	statusName?: string | null
	paymentRequirementId?: number | null
}

export interface PaymentRequirementsItemCreationSignData extends Pick<PaymentRequirementsItem, 'documentNumber'
	| 'documentDate'
	| 'requesterName'
	| 'requesterAccountNumber'
	| 'requesterMfo'
	| 'requesterInn'
	| 'requesterPinfl'
	| 'debitAccountNumber'
	| 'debitMfo'
	| 'debitName'
	| 'debitInn'
	| 'debitPinfl'
	| 'purposeCode'
	| 'purpose'
	| 'requesterMfoName'
	| 'debitMfoName'> {}

export interface PaymentRequirementsItemSignData extends Pick<PaymentRequirementsItem, 'paymentType'
	| 'paymentTypeName'
	| 'purposeCodeName'
	| 'unpaid'
	| 'unpaidName'
	| 'amount'
	| 'paymentRequirementId'>,
	Omit<PaymentRequirementsItemCreationSignData, 'requesterMfoName'
	| 'debitMfoName'> {}

export interface PaymentRequirementsIncomingSignResponse {
	total?: number | null
	successfullyProcessed?: number | null
}

export interface PaymentRequirementsCardIndexItem extends Pick<PaymentRequirementsHistoryItem, 'dueDate'
	| 'documentDate'
	| 'documentNumber'
	| 'requesterMfo'
	| 'requesterName'
	| 'status'
	| 'amount'
	| 'purpose'
	| 'requesterAccountNumber'> {
	amountLeft?: number | null
	documentIdInk?: number | null
	documentType?: string | null
	customerBranch?: string | null
}

export interface PaymentRequirementsCardIndexDetailsItem extends PaymentRequirementsHistoryItem,
	PaymentRequirementsCardIndexItem {}

export interface PaymentRequirementsCardIndexParams {
	kId?: number
	paymentRequirementId?: number
}

export type PaymentRequirementsItemStatus = PaymentRequirementsIncomingStatus
	| PaymentRequirementsOutgoingStatus